/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VideoNarrativesClassificationsRequest
 */
export interface VideoNarrativesClassificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof VideoNarrativesClassificationsRequest
     */
    awemeId: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof VideoNarrativesClassificationsRequest
     */
    narrativesIds: Array<number>;
}

/**
 * Check if a given object implements the VideoNarrativesClassificationsRequest interface.
 */
export function instanceOfVideoNarrativesClassificationsRequest(value: object): value is VideoNarrativesClassificationsRequest {
    if (!('awemeId' in value) || value['awemeId'] === undefined) return false;
    if (!('narrativesIds' in value) || value['narrativesIds'] === undefined) return false;
    return true;
}

export function VideoNarrativesClassificationsRequestFromJSON(json: any): VideoNarrativesClassificationsRequest {
    return VideoNarrativesClassificationsRequestFromJSONTyped(json, false);
}

export function VideoNarrativesClassificationsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VideoNarrativesClassificationsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'awemeId': json['aweme_id'],
        'narrativesIds': json['narratives_ids'],
    };
}

export function VideoNarrativesClassificationsRequestToJSON(json: any): VideoNarrativesClassificationsRequest {
    return VideoNarrativesClassificationsRequestToJSONTyped(json, false);
}

export function VideoNarrativesClassificationsRequestToJSONTyped(value?: VideoNarrativesClassificationsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'aweme_id': value['awemeId'],
        'narratives_ids': value['narrativesIds'],
    };
}

